/*
 * Date: 2020-07-28 18:18:15
 * LastEditors: Mosuzi
 * LastEditTime: 2020-08-05 19:49:50
 * Description: 个人中心需要的接口
 * Author: Mosuzi
 */
export default {
  module: 'PERSONAL_CENTER',
  SWITCH_TENANT: {
    url: '/xdap-admin/tenant/switch/tenant',
    method: 'post'
  },
  QUERY_USER_INFO: {
    url: '/xdap-admin/user/query/userInfo',
    method: 'post',
    disableSuccessMsg: true
  },
  UPDATE_USER_USERINFO: {
    url: '/xdap-admin/user/update/userInfo',
    method: 'post'
  },
  UPLOAD_AVATAR: {
    url: '/xdap-admin/attachments/simpleUploadFile',
    method: 'post'
  },
  SEND_SME_CODE: {
    url: '/xdap-admin/user/send/smsCode',
    method: 'post'
  },
  UPDATE_PHONE: {
    url: '/xdap-admin/user/update/userPhone',
    method: 'post'
  },
  UPDATE_EMAIL: {
    url: '/xdap-admin/user/update/userEmail',
    method: 'post'
  },
  UPDATE_PASSWORD: {
    url: '/xdap-admin/user/update/userPassword',
    method: 'post'
  },
  SEND_EMAIL_CODE: {
    url: '/xdap-admin/user/send/emailCode',
    method: 'post'
  }
}
